/**
 * Look sensitivity and vertical inversion.
 *
 * Changes apply immediately — no Save button — because the only way to judge a
 * sensitivity value is to move the view and feel it. Persistence is handled by the store.
 */

import { useGameStore } from '../store/gameStore';
import { MAX_LOOK_SENSITIVITY, MIN_LOOK_SENSITIVITY } from '../game/settings';

const SENSITIVITY_STEP = 0.1;

export function SettingsPanel() {
  const settings = useGameStore((store) => store.settings);
  const updateSettings = useGameStore((store) => store.updateSettings);

  return (
    <div className="settings-panel">
      <div className="settings-field">
        <label htmlFor="look-sensitivity">Look sensitivity</label>
        <input
          id="look-sensitivity"
          type="range"
          min={MIN_LOOK_SENSITIVITY}
          max={MAX_LOOK_SENSITIVITY}
          step={SENSITIVITY_STEP}
          value={settings.lookSensitivity}
          // The raw number is meaningless read aloud on its own; name the unit.
          aria-valuetext={`${settings.lookSensitivity.toFixed(1)} times`}
          onChange={(event) => {
            void updateSettings({ lookSensitivity: Number(event.target.value) });
          }}
        />
      </div>

      <div className="settings-field settings-field--inline">
        <input
          id="invert-look"
          type="checkbox"
          checked={settings.invertLookY}
          onChange={(event) => {
            void updateSettings({ invertLookY: event.target.checked });
          }}
        />
        <label htmlFor="invert-look">Invert vertical look</label>
      </div>

      {/* Not a setting — the deploy this session is running, so a report of a problem
          can name the build it came from. */}
      <p className="settings-build-id">Build {__BUILD_ID__}</p>
    </div>
  );
}
